// Fine-grained permission helpers.  Mirror of backend PERMISSION_MODULES.
// Any UI element that gates on module rights should go through hasPermission.

export const PERMISSION_MODULES = [
  { key: "lager", label: "Lager" },
  { key: "rezepturen", label: "Rezepturen" },
  { key: "produktion", label: "Produktion" },
  { key: "verkauf", label: "Verkauf" },
  { key: "rechnungen", label: "Rechnungen" },
  { key: "versand", label: "Versand" },
  { key: "einkauf", label: "Einkauf" },
  { key: "crm", label: "CRM / Kunden" },
  { key: "labels", label: "Etiketten" },
  { key: "einstellungen", label: "Einstellungen" },
];

export const PERMISSION_ACTIONS = [
  { key: "read", label: "Lesen" },
  { key: "edit", label: "Bearbeiten" },
  { key: "delete", label: "Löschen" },
];

export function emptyPermissions() {
  const out = {};
  for (const m of PERMISSION_MODULES) {
    out[m.key] = { read: false, edit: false, delete: false };
  }
  return out;
}

export function fullPermissions() {
  const out = {};
  for (const m of PERMISSION_MODULES) {
    out[m.key] = { read: true, edit: true, delete: true };
  }
  return out;
}

/**
 * Returns true if `user` may perform `action` on `module`.
 * Superadmin and legacy `admin` role always pass.
 */
export function hasPermission(user, module, action = "read") {
  if (!user) return false;
  if (user.is_superadmin) return true;
  if (user.role === "admin") return true;
  const perms = user.permissions || {};
  const mp = perms[module];
  return !!(mp && mp[action]);
}

// Standard role templates the superadmin can apply from the matrix.
export const ROLE_TEMPLATES = [
  {
    key: "warehouse",
    label: "Lager-Mitarbeiter",
    description: "Voller Zugriff auf Lager, Rezepturen, Produktion & Einkauf. Kein Löschen.",
    permissions: {
      lager: { read: true, edit: true, delete: false },
      rezepturen: { read: true, edit: true, delete: false },
      produktion: { read: true, edit: true, delete: false },
      verkauf: { read: false, edit: false, delete: false },
      rechnungen: { read: false, edit: false, delete: false },
      versand: { read: true, edit: true, delete: false },
      einkauf: { read: true, edit: true, delete: false },
      crm: { read: true, edit: false, delete: false },
      labels: { read: true, edit: true, delete: false },
      einstellungen: { read: false, edit: false, delete: false },
    },
  },
  {
    key: "sales",
    label: "Verkauf / Innendienst",
    description: "Kunden, Bestellungen, Lieferscheine & Rechnungen bearbeiten. Lager nur lesen.",
    permissions: {
      lager: { read: true, edit: false, delete: false },
      rezepturen: { read: true, edit: false, delete: false },
      produktion: { read: true, edit: false, delete: false },
      verkauf: { read: true, edit: true, delete: false },
      rechnungen: { read: true, edit: true, delete: false },
      versand: { read: true, edit: true, delete: false },
      einkauf: { read: false, edit: false, delete: false },
      crm: { read: true, edit: true, delete: false },
      labels: { read: true, edit: false, delete: false },
      einstellungen: { read: false, edit: false, delete: false },
    },
  },
  {
    key: "viewer",
    label: "Nur-Leser",
    description: "Nur Lesezugriff auf alle Module. Kein Bearbeiten oder Löschen.",
    permissions: (() => {
      const p = emptyPermissions();
      for (const m of PERMISSION_MODULES) p[m.key].read = true;
      p.einstellungen = { read: false, edit: false, delete: false };
      return p;
    })(),
  },
  {
    key: "none",
    label: "Keine Rechte",
    description: "Alles auf false zurücksetzen (Standard für neue Benutzer).",
    permissions: emptyPermissions(),
  },
];
